import React, { useState } from "react";
import { Button } from "antd";

import { postFetch } from "../../utils/Util";

interface ButtonWithLoadingProps {
  className?: string;
  style?: React.CSSProperties;
  size?: "small" | "middle" | "large";
  disabled?: boolean;
  block?: boolean;
  postURL: string;
  postBody?: Record<string, any>;
  postHandleResponse?: (resp: any, date?: string, etag?: string) => void;
  postHandleError?: (err: Error) => void;
  children: React.ReactNode;
}

const ButtonWithLoading: React.FC<ButtonWithLoadingProps> = ({
  className,
  style,
  size,
  disabled,
  block,
  postURL,
  postBody,
  postHandleResponse,
  postHandleError,
  children,
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <Button
      disabled={disabled || loading}
      loading={loading}
      className={className}
      style={style}
      size={size}
      block={block}
      onClick={() => {
        setLoading(true);
        postFetch(
          postURL,
          postBody ? postBody : {},
          (resp, date, etag) => {
            setLoading(false);
            if (postHandleResponse) {
              postHandleResponse(resp, date, etag);
            }
          },
          (err) => {
            setLoading(false);
            if (postHandleError) {
              postHandleError(err);
            }
          }
        );
      }}
    >
      {children}
    </Button>
  );
};

export default ButtonWithLoading;
